<template>
    <div class="shop-container">
        <ph-header :title='title' :fixed='downloadApp'>
            <van-icon name="arrow-left" size="20px" slot="left" @click="$router.back(-1)" />
        </ph-header>
        <header v-if="topicCover">
          <div class="cover" :style="`background-image:url(${topicCover})`"></div>
          <div class="topic-describe fz24">
            {{topicDescribe}}
          </div>
        </header>
        <div class="content">
            <van-list v-model="loading" :finished="finished" finished-text="已加载全部商品" @load="onReachBottom">
              <good-grid v-if="!isEmpty" :list.sync="goodsList"></good-grid>
              <emptyData v-if="isEmpty" message="暂无商品"></emptyData>
            </van-list>
        </div>
    </div>
</template>

<script>
import PhHeader from '@/components/common/Header'
import GoodGrid from '@/components/business/GoodGrid'
import { getActivityDetails, getActivityGoodsList } from '@/api/good'
import EmptyData from '@/components/business/EmptyData'

export default {
  name: 'shopTopicDetail',
  components: {
    PhHeader,
    GoodGrid,
    EmptyData
  },
  data () {
    return {
      activeId: '',
      downloadApp: true,
      title: '复古回潮，懂时尚的你最爱谁',
      //   goodsList: [],

      topicCover: '',
      topicDescribe: '',
      goodsList: [],
      page: 1,
      pagecount: 10,
      pageTotal: 0,
      total: 0,
      loading: false,
      finished: false,
      isEmpty: false,
      criteria: {}
    }
  },
  mounted () {
    this.activeId = this.$route.params.id
    getActivityDetails({ activityId: this.activeId }).then(res => {
      this.topicCover = res.activityPicture
      document.title = res.activityTitle
      this.topicDescribe = res.activityDescription
      
    })
    this.getData(true)
  },
  methods: {
    // 获取数据
    getData (refresh) {
      this.criteria.activityId = this.activeId
      this.criteria.pageIndex = this.page
      this.criteria.pageSize = this.pageCount
      getActivityGoodsList(this.criteria).then(res => {
        if (refresh) {
          this.goodsList = res.result || []
        } else {
          this.goodsList = [...this.goodsList, ...res.result]
        }

        this.total = res.total
        this.pageTotal = res.pageCount
        
        if (this.goodsList.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.loading = false
      }).catch(error => {
        this.$toast(error)
      })
    },
    // 加载更多
    onReachBottom () {
      this.loading = true
      if(this.goodsList.length > 0) {
        if (this.page > this.pageTotal) { // 已经到底部
          this.finished = true
        }
      }
      this.page++
      setTimeout(() => {
        this.getData()
      }, 300)
    }
  }
}
</script>

<style lang="less" scoped>
.shop-container{
  header{
    .cover{
      padding-top: 60%;
      background-size:contain;
      background-position: left top;
      background-repeat: no-repeat;
    }
    background: #fff;
    .topic-describe{
      padding: 20px 24px ;
    }
  }
  .content{
      margin-top: 40px;
      padding: 0 24px;
  }
}

</style>
